import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-r from-teal-500 to-blue-600 text-white">
        <div className="container mx-auto px-6 text-center">
          <h1 className="text-5xl md:text-6xl font-bold mb-6">About Tenny & Co Artistry</h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Where creativity meets excellence in Port Harcourt
          </p>
        </div>
      </section>

      {/* Founder Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <img 
                src="https://static.readdy.ai/image/34c54877ea329bad86119ae5706d9da2/b8e3c654067fed91b76fca4f10330356.png"
                alt="Gospel Tennyson Jaja"
                className="w-full rounded-2xl shadow-2xl object-cover object-top"
              />
            </div>
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">Meet Gospel Tennyson Jaja</h2>
              <p className="text-xl text-gray-700 mb-6 leading-relaxed">
                <strong>Gospel Tennyson Jaja</strong> is a multi-talented artist, painter, graphic designer, educator, and storyteller based in Port Harcourt, Nigeria. With a strong foundation in Architecture from <strong>Ken Saro Wiwa Polytechnic</strong>, Gospel combines technical precision with artistic creativity to deliver exceptional work across multiple disciplines.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                His journey in the creative arts spans years of dedicated practice, continuous learning, and a passion for bringing visions to life. From stunning pencil portraits to vibrant canvas paintings, from compelling graphic designs to engaging storytelling content, Gospel's work reflects his commitment to excellence and innovation.
              </p>
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                As an educator, Gospel is passionate about nurturing the next generation of creative minds. He provides comprehensive educational support for Cultural and Creative Arts, helping students and teachers with lesson notes, question papers, and schemes of work tailored to the Nigerian junior secondary school curriculum.
              </p>
              <div className="flex flex-wrap gap-4 mt-8">
                <div className="bg-teal-50 px-6 py-3 rounded-full">
                  <span className="font-semibold text-teal-700">Artist</span>
                </div>
                <div className="bg-purple-50 px-6 py-3 rounded-full">
                  <span className="font-semibold text-purple-700">Designer</span>
                </div>
                <div className="bg-blue-50 px-6 py-3 rounded-full">
                  <span className="font-semibold text-blue-700">Educator</span>
                </div>
                <div className="bg-red-50 px-6 py-3 rounded-full">
                  <span className="font-semibold text-red-700">Storyteller</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Brand Story */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-center">The TCA Story</h2>
            <div className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                <strong>Tenny & Co Artistry (TCA)</strong> was born from a simple yet powerful vision: to create a space where art, design, and education converge to inspire and transform. Founded by Gospel Tennyson Jaja, TCA has grown from a personal passion into Port Harcourt's premier creative brand.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Operating from two strategic locations in <strong>Rukpokwu</strong> and <strong>Rumuodara</strong>, Port Harcourt, TCA serves a diverse clientele ranging from individuals seeking custom portraits to businesses needing professional brand designs, and educators looking for quality teaching materials.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our motto, <strong>"We have got much to offer,"</strong> is not just a tagline—it's a promise. Every project we undertake, whether it's a commissioned painting, a social media graphic, or an educational resource, is executed with the same level of dedication, creativity, and professionalism.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Today, TCA stands as a testament to what passion, skill, and commitment can achieve. We continue to push boundaries, explore new creative territories, and deliver work that exceeds expectations.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Values & Mission */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold mb-16 text-center">Our Values & Mission</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-16">
            <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-8">
              <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-lightbulb-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Creativity</h3>
              <p className="text-gray-700">
                We believe in pushing creative boundaries and exploring innovative approaches to bring unique visions to life.
              </p>
            </div>

            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-2xl p-8">
              <div className="w-16 h-16 bg-purple-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-star-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Excellence</h3>
              <p className="text-gray-700">
                Every project is executed with meticulous attention to detail and a commitment to delivering the highest quality.
              </p>
            </div>

            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-2xl p-8">
              <div className="w-16 h-16 bg-blue-500 rounded-full flex items-center justify-center mb-6">
                <i className="ri-heart-line text-3xl text-white"></i>
              </div>
              <h3 className="text-2xl font-bold mb-4">Integrity</h3>
              <p className="text-gray-700">
                We build lasting relationships through honest communication, transparency, and delivering on our promises.
              </p>
            </div>
          </div>

          <div className="bg-gradient-to-r from-teal-500 to-blue-600 rounded-2xl p-12 text-white text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-6">Our Mission</h3>
            <p className="text-xl max-w-3xl mx-auto leading-relaxed">
              To empower individuals, businesses, and educators through exceptional art, innovative design, and quality educational content that inspires creativity and drives success across Port Harcourt and beyond.
            </p>
          </div>
        </div>
      </section>

      {/* Strengths */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl md:text-5xl font-bold mb-16 text-center">Our Strengths</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-palette-line text-2xl text-teal-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Versatile Expertise</h4>
                  <p className="text-gray-600">
                    From traditional art to digital design, we master multiple creative disciplines.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-user-heart-line text-2xl text-purple-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Client-Focused</h4>
                  <p className="text-gray-600">
                    Your satisfaction is our priority. We listen, understand, and deliver.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-graduation-cap-line text-2xl text-blue-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Educational Excellence</h4>
                  <p className="text-gray-600">
                    Comprehensive teaching materials aligned with Nigerian curriculum standards.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-time-line text-2xl text-red-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Timely Delivery</h4>
                  <p className="text-gray-600">
                    We respect deadlines and ensure projects are completed on schedule.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-yellow-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-price-tag-3-line text-2xl text-yellow-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Competitive Pricing</h4>
                  <p className="text-gray-600">
                    Quality work at fair prices that provide excellent value for money.
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-xl p-6 shadow-md">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                  <i className="ri-map-pin-line text-2xl text-green-600"></i>
                </div>
                <div>
                  <h4 className="text-xl font-bold mb-2">Local Presence</h4>
                  <p className="text-gray-600">
                    Two convenient locations in Port Harcourt for easy accessibility.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Info */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 rounded-2xl p-12 text-white">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold mb-4">Get In Touch</h2>
              <p className="text-xl text-gray-300">We're here to help bring your creative vision to life</p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-center">
              <div>
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-phone-line text-3xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Call Us</h4>
                <a href="tel:08162117807" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer block">
                  08162117807
                </a>
                <a href="tel:09032271030" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer block">
                  09032271030
                </a>
              </div>

              <div>
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-map-pin-line text-3xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Visit Us</h4>
                <p className="text-gray-300">Rukpokwu, Port Harcourt</p>
                <p className="text-gray-300">Rumuodara, Port Harcourt</p>
              </div>

              <div>
                <div className="w-16 h-16 bg-teal-500 rounded-full flex items-center justify-center mx-auto mb-4">
                  <i className="ri-message-line text-3xl"></i>
                </div>
                <h4 className="text-xl font-bold mb-2">Message Us</h4>
                <Link to="/contact" className="text-gray-300 hover:text-teal-400 transition-colors cursor-pointer">
                  Send a Message
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}